import { render } from "./contact_form.vue?vue&type=template&id=faf61d2c"
import script from "./contact_form.vue?vue&type=script&lang=js"
export * from "./contact_form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__